<template>
  <b-card
    no-body
    class="workflows"
    header-class="table-details-header"
  >
    <div
      slot="header"
      class="d-flex justify-content-between align-items-center"
      @click="showWorkflows = !showWorkflows"
    >
      <span>Workflows</span>
      <font-awesome-icon
        id="workflowsCollapse"
        v-b-toggle.workflows-collapse
        :icon="['fan', showWorkflows ? 'chevron-up' : 'chevron-down']"
      />
    </div>
    <b-collapse
      id="table-details-collapse"
      :visible="showWorkflows"
      class="mt-2"
    >
      <b-card-body>
        <div class="row">
          <div class="col-sm-4 mb-3">
            <h5>Mid-load</h5>
            <input-widget
              :id="'workflowDefinitionId'"
              :model="workflowsState"
              :field="workflowsSchema.midLoad"
              @change="onWorkflowsIdChange('entityConfig.MidLoadWorkflow.WorkflowDefinitionId', $event)"
            />
            <input-widget
              :id="`checkColCount`"
              :model="midLoadWorkflow"
              :field="workflowsSchema.checkColumnCount"
              :disabled="!workflowsState.WorkflowDefinitionId"
              :is-switch="true"
              @change="onMidLoadCheckChange('entityConfig.MidLoadWorkflow.CheckColumnCount', $event)"
            />
            <input-widget
              :id="`checkRowCount`"
              :model="midLoadWorkflow"
              :field="workflowsSchema.checkRowCount"
              :disabled="!workflowsState.WorkflowDefinitionId"
              :is-switch="true"
              @change="onMidLoadCheckChange('entityConfig.MidLoadWorkflow.CheckRowCount', $event)"
            />
            <div class="d-flex align-items-center position-relative mid-load-columns">
              <label class="mb-0 mr-2">Columns:</label>
              <div class="d-flex justify-content-space-between button-wrapper">
                <div class="d-flex badge-wrapper bg-light">
                  <div
                    class="d-flex pr-2 items-gap border-right"
                  >
                    <b-badge
                      v-for="col in midLoadWorkflow.Columns"
                      :key="`mid-load-column-${col}`"
                      variant="info"
                      size="sm"
                      class="filter-item-badge"
                      @click="onDeleteMidLoadColumn(col)"
                    >
                      <span class="badge-text">
                        {{ fields.find(f => f.fieldGuid === col).displayName }}
                      </span>
                      <span
                        v-b-tooltip.hover
                        title="Clear"
                        class="ml-1 delete-filter-item"
                      >
                        <font-awesome-icon :icon="['fas', 'times']" />
                      </span>
                    </b-badge>
                  </div>
                  <b-dropdown
                    id="viewAsUserDropdown"
                    size="sm"
                    variant="outline-primary"
                    text="Add column"
                    :disabled="!workflowsState.WorkflowDefinitionId"
                  >
                    <b-dropdown-item
                      v-for="f in fields.filter(f => !midLoadWorkflow.Columns.includes(f.fieldGuid))"
                      :key="f.fieldGuid"
                      @click="onAddColumnToMidLoad(f)"
                    >
                      {{ f.displayName }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4 mb-3">
            <h5>Post-load</h5>
            <input-widget
              :id="'postLoadOrchestrationWorkflowId'"
              :model="workflowsState"
              :field="workflowsSchema.postLoad"
              @change="onWorkflowsIdChange('postLoadOrchestrationWorkflowId', $event)"
            />
          </div>
          <div class="col-sm-4 mb-3">
            <h5>Post-delete</h5>
            <input-widget
              :id="'postDeleteOrchestrationWorkflowId'"
              :model="workflowsState"
              :field="workflowsSchema.postDelete"
              @change="onWorkflowsIdChange('postDeleteOrchestrationWorkflowId', $event)"
            />
          </div>
        </div>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>
<script>

import {createNamespacedHelpers} from 'vuex';
import InputWidget from '@/core/components/complex-table/components/InputWidget';
const {mapState, mapActions, mapGetters, mapMutations} = createNamespacedHelpers('dataManagement');

export default {
  name: 'Workflows',
  components: {
    InputWidget,
  },
  props: {
    orchestration: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
    },
    postLoadOrchestrationWorkflowId: {
      type: String,
    },
    postDeleteOrchestrationWorkflowId: {
      type: String,
    },
    entityConfig: {
      type: Object,
      default: {
        EntityType: 'none',
        MidLoadWorkflow: null,
        PostedPeriodLookupFieldGuid: null,
        PostedPeriodTransactionDateGuid: null,
        PostedStatusMDMFieldGuid: null,
      },
    },
  },
  data() {
    return {
      showWorkflows: true,
      workflowsSchema: {
        midLoad: {
          type: 'select',
          required: false,
          label: '',
          name: 'WorkflowDefinitionId',
          data: {
            options: [
              {text: '', value: null},
              ...this.orchestration,
            ],
          },
        },
        checkColumnCount: {
          type: 'checkbox',
          required: false,
          label: 'Check Column count',
          name: 'CheckColumnCount',
        },
        checkRowCount: {
          type: 'checkbox',
          required: false,
          label: 'Check Row count',
          name: 'CheckRowCount',
        },
        postLoad: {
          type: 'select',
          required: false,
          label: '',
          name: 'postLoadOrchestrationWorkflowId',
          data: {
            options: [
              {text: '', value: null},
              ...this.orchestration,
            ],
          },
        },
        postDelete: {
          type: 'select',
          required: false,
          label: '',
          name: 'postDeleteOrchestrationWorkflowId',
          data: {
            options: [
              {text: '', value: null},
              ...this.orchestration,
            ],
          },
        },
      },
      workflowsState: {
        WorkflowDefinitionId: null,
        postLoadOrchestrationWorkflowId: null,
        postDeleteOrchestrationWorkflowId: null,
      },
      midLoadWorkflow: {
        CheckColumnCount: false,
        CheckRowCount: false,
        Columns: [],
      },
    };
  },
  watch: {
    ['entityConfig']: {
      handler(newData) {
        if(!!newData?.MidLoadWorkflow?.Columns) {
          this.midLoadWorkflow.Columns = this.getMidLoadWorkflowColumnsInFieldGuid([...newData?.MidLoadWorkflow?.Columns]);
        }
      },
      deep: true,
      immediate: true,
    },
    ['fields']: {
      handler() {
        if (this.entityConfig?.MidLoadWorkflow?.Columns && this.entityConfig?.MidLoadWorkflow?.Columns.length > 0) {
          this.midLoadWorkflow.Columns = this.getMidLoadWorkflowColumnsInFieldGuid([...this.entityConfig?.MidLoadWorkflow?.Columns]);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(['fieldTypes']),
  },
  methods: {
    onAddColumnToMidLoad(field) {
      const newColumns = [...this.midLoadWorkflow.Columns, field.fieldGuid];
      this.midLoadWorkflow.Columns = [...newColumns];
      this.$emit('on-workflow-change', { propertyName: 'entityConfig.MidLoadWorkflow.Columns', value: this.getMidLoadWorkflowColumnsInName(newColumns)});
    },

    onDeleteMidLoadColumn(fieldGuid) {
      const newColumns = this.midLoadWorkflow.Columns.filter(f => f !== fieldGuid);
      this.midLoadWorkflow.Columns = [...newColumns];
      this.$emit('on-workflow-change', { propertyName: 'entityConfig.MidLoadWorkflow.Columns', value: this.getMidLoadWorkflowColumnsInName(newColumns)});
    },

    onWorkflowsIdChange(propertyName, value) {
      this.$emit('on-workflow-change', { propertyName, value});

      if (propertyName === 'entityConfig.MidLoadWorkflow.WorkflowDefinitionId' && !value) {
        this.midLoadWorkflow.CheckColumnCount = false;
        this.$emit('on-workflow-change', { propertyName: 'entityConfig.MidLoadWorkflow.CheckColumnCount', value: false});

        this.midLoadWorkflow.CheckRowCount = false;
        this.$emit('on-workflow-change', { propertyName: 'entityConfig.MidLoadWorkflow.CheckRowCount', value: false});

        this.midLoadWorkflow.Columns = [];
        this.$emit('on-workflow-change', { propertyName: 'entityConfig.MidLoadWorkflow.Columns', value: []});
      } else {
        this.$emit('on-workflow-change', { propertyName: 'entityConfig.MidLoadWorkflow.CheckColumnCount', value: this.midLoadWorkflow.CheckColumnCount});
        this.$emit('on-workflow-change', { propertyName: 'entityConfig.MidLoadWorkflow.CheckRowCount', value: this.midLoadWorkflow.CheckRowCount});
      }
    },

    onMidLoadCheckChange(propertyName, value) {
      this.$emit('on-workflow-change', { propertyName, value});
    },

    getMidLoadWorkflowColumnsInName(data) {
      return data.map((col) => {
        return this.fields.find(f => f.fieldGuid === col).name;
      });
    },

    getMidLoadWorkflowColumnsInFieldGuid(data) {
      return data.reduce((acc, col) => {
        const field = this.fields.find(f => f.name === col);
        if (field) {
          acc.push(field.fieldGuid);
        }
        return acc;
      }, []);
    },
  },
  async mounted() {
    if (!!this.entityConfig?.MidLoadWorkflow?.WorkflowDefinitionId) {
      this.workflowsState.WorkflowDefinitionId = this.entityConfig.MidLoadWorkflow.WorkflowDefinitionId;
    }
    if (!!this.entityConfig?.MidLoadWorkflow?.CheckColumnCount) {
      this.midLoadWorkflow.CheckColumnCount = this.entityConfig.MidLoadWorkflow.CheckColumnCount;
    }
    if (!!this.entityConfig?.MidLoadWorkflow?.CheckRowCount) {
      this.midLoadWorkflow.CheckRowCount = this.entityConfig.MidLoadWorkflow.CheckRowCount;
    }
    if (this.entityConfig?.MidLoadWorkflow?.Columns && this.entityConfig?.MidLoadWorkflow?.Columns.length > 0) {
      this.midLoadWorkflow.Columns = this.getMidLoadWorkflowColumnsInFieldGuid([...this.entityConfig?.MidLoadWorkflow?.Columns]);
    }
    if (!!this.postLoadOrchestrationWorkflowId) {
      this.workflowsState.postLoadOrchestrationWorkflowId = this.postLoadOrchestrationWorkflowId;
    }
    if (!!this.postDeleteOrchestrationWorkflowId) {
      this.workflowsState.postDeleteOrchestrationWorkflowId = this.postDeleteOrchestrationWorkflowId;
    }
  },
};
</script>

<style lang="scss">
.card-header {
    cursor: pointer;
  }
.l-input-widget {
  > div {
    margin-bottom: 0;
  }
}
.items-gap {
  gap: 10px;
}
.mid-load-columns {
  z-index: 1;
}
#viewAsUserDropdown {
  .dropdown-menu {
    max-height: 300px !important;
    overflow-y: auto;
  }
}
</style>
